<template>
    <div class="p-list__map-loader" v-if='isLoading'>
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
            <circle cx="50" cy="50" r="32" stroke-width="5" stroke="#1c1b28" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round"/>
        </svg>
    </div>
    <yandex-map
        :settings='mapSettings'
        :zoom='zoom'
        :coords='center'
        :controls='mapControls'
        :options='mapOptions'
        :cluster-options='clusterOptions'
        @map-was-initialized='initMapHandler'>
        <template
            v-for="marker in markersList"
            :key="marker.id">
            <ymap-marker
                :coords='[marker.lat, marker.long]'
                :marker-id='marker.id'
                :icon='markerDefaultIcon'
                :hintContent='new Intl.NumberFormat("ru-RU").format(marker.price) + " ₽"'
                :marker-events='["click"]'
                cluster-name='map-cluster'
                @click.stop='clickMarker(marker)' />
        </template>
    </yandex-map>
    <Transition>
        <map-modal
            v-if="mapModal"
            :map-modal-data="mapItem"
            :is-loading="mapItemIsLoading"
            @close-map-modal="closeMapModal"
            @show-form="showForm" />
    </Transition>
</template>

<script>
    import { yandexMap, ymapMarker } from 'vue-yandex-maps'
    import {mapState} from 'vuex'
    import {mapItemActionTypes} from '../../../store/modules/land/property/modules/map-item'
    import MapModal from './MapModal'

    export default {
        name: 'Map',
        components: {
            yandexMap,
            ymapMarker,
            MapModal
        },
        props: {
            mapData: {
                type: Object,
                default: false
            }
        },
        data() {
            return {
                apiUrl: '/api/v2/land/property/item',
                balloonData: {},
                isLoading: true,
                mapModal: false,
                mapSettings: {
                    apiKey: '07ce8f81-4778-4452-b6a8-b99ae4ad1522',
                    lang: 'ru_RU',
                    coordorder: 'latlong',
                    enterprise: false,
                    version: '2.1',
                },
                zoom: 4,
                minZoom: 3,
                maxZoom: 23,
                mapControls: ['zoomControl'],
                mapOptions: { suppressMapOpenBlock: true, minZoom: 3, maxZoom: 23 },
                center: [55.755864, 37.617698],
                mapInstance: null,
                markerDefaultIcon: {
                    layout: 'default#imageWithContent',
                    imageHref: '/static/v2/src/img/land/icons/map-marker-default.svg',
                    content: '',
                    imageSize: [20, 20],
                    imageOffset: [-10, -10],
                    contentOffset: [-40, -22],
                    contentLayout: '<div style="background: white; width: 100px; color: #252628; font-weight: 600; padding: 2px; border-radius: 4px; box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);">$[properties.hintContent]</div>'
                },
                clusterOptions: {
                    'map-cluster': {
                        clusterIcons: [
                            {
                                href: '/static/v2/src/img/land/icons/map-cluster-icon.svg',
                                size: [60, 60],
                                offset: [-30, -30],
                            },
                            {
                                href: '/static/v2/src/img/land/icons/map-cluster-icon.svg',
                                size: [70, 70],
                                offset: [-35, -35],
                            },
                            {
                                href: '/static/v2/src/img/land/icons/map-cluster-icon.svg',
                                size: [80, 80],
                                offset: [-40, -40],
                            },
                        ],
                        preset: 'map-cluster',
                        zoomMargin: 20,
                    },
                },
            }
        },
        computed: {
            ...mapState({
                mapItemIsLoading: state => state.mapItem.isLoading,
                mapItem: state => state.mapItem.data,
                mapItemError: state => state.mapItem.error,
            }),
            mapCenter() {
                return this.center;
            },
            markersList() {
                return this.mapData.data.data;
            },
        },
        methods: {
            showForm (offer) {
                this.$emit('showForm', offer)
            },

            initMapHandler(payload) {
                this.mapInstance = payload;
                window.domYMAPS = payload;
                setTimeout(() => {
                this.isLoading = false;
                }, 1000);
            },

            changeMapCenter(value) {
                this.center = value;
            },
            clickMarker(marker) {
                const {lat, long, id} = marker
                this.mapModal = true
                this.$store.dispatch(mapItemActionTypes.getMapItem, {apiUrl: `${this.apiUrl}/${id}/`})
                this.changeMapCenter([lat, long]);
            },

            closeMapModal () {
                this.mapModal = false
            }
        },
    }
</script>